/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Daily_Task_DurationInputs */

const en_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plant any tree for ${i?.number} mins`)
};

const ar_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ازرع أي شجرة لمدة ${i?.number} دقيقة`)
};

const de_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pflanze einen beliebigen Baum für ${i?.number} min`)
};

const es_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Planta cualquier árbol durante ${i?.number} mins`)
};

const fr_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Planter un arbre pendant ${i?.number} minutes`)
};

const it_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pianta un albero qualsiasi per ${i?.number} minuti`)
};

const ja_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`好きな木を ${i?.number} 分間植える`)
};

const ko_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} 분간 아무 나무 심기`)
};

const pt_br_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plante qualquer árvore por ${i?.number} minutos`)
};

const ru_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Посадка любого дерева в течение ${i?.number} мин.`)
};

const th_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ปลูกต้นไม้ใด ๆ เป็นเวลา ${i?.number} นาที`)
};

const tr_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} dakika boyunca herhangi bir ağaç dik`)
};

const zh_cn_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`种植任意树种 ${i?.number} 分钟`)
};

const zh_tw_daily_task_duration = /** @type {(inputs: Daily_Task_DurationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`種植任意樹種 ${i?.number} 分鐘`)
};

/**
* | output |
* | --- |
* | "Plant any tree for {number} mins" |
*
* @param {Daily_Task_DurationInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_task_duration = /** @type {((inputs: Daily_Task_DurationInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Task_DurationInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_task_duration(inputs)
	if (locale === "ar") return ar_daily_task_duration(inputs)
	if (locale === "de") return de_daily_task_duration(inputs)
	if (locale === "es") return es_daily_task_duration(inputs)
	if (locale === "fr") return fr_daily_task_duration(inputs)
	if (locale === "it") return it_daily_task_duration(inputs)
	if (locale === "ja") return ja_daily_task_duration(inputs)
	if (locale === "ko") return ko_daily_task_duration(inputs)
	if (locale === "pt_br") return pt_br_daily_task_duration(inputs)
	if (locale === "ru") return ru_daily_task_duration(inputs)
	if (locale === "th") return th_daily_task_duration(inputs)
	if (locale === "tr") return tr_daily_task_duration(inputs)
	if (locale === "zh_cn") return zh_cn_daily_task_duration(inputs)
	return zh_tw_daily_task_duration(inputs)
});